webpackJsonp([49683490770531],{

/***/ 1993:
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"allMarkdownRemark": {
				"edges": [
					{
						"node": {
							"fields": {
								"slug": "/app-credits"
							},
							"frontmatter": {
								"title": "App Credits",
								"date": null,
								"tags": null,
								"category": null,
								"cover": null,
								"type": "page",
								"month": null,
								"author": null,
								"year": null,
								"description": null,
								"external": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/i-os-credits"
							},
							"frontmatter": {
								"title": "iOS Credits",
								"date": null,
								"tags": null,
								"category": null,
								"cover": null,
								"type": "page",
								"month": null,
								"author": null,
								"year": null,
								"description": null,
								"external": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/terms-of-service"
							},
							"frontmatter": {
								"title": "Terms of Service",
								"date": null,
								"tags": null,
								"category": null,
								"cover": null,
								"type": "page",
								"month": null,
								"author": null,
								"year": null,
								"description": null,
								"external": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/wawafm"
							},
							"frontmatter": {
								"title": "wawafm",
								"date": null,
								"tags": null,
								"category": null,
								"cover": null,
								"type": "page",
								"month": null,
								"author": null,
								"year": null,
								"description": null,
								"external": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/maps-in-flutter"
							},
							"frontmatter": {
								"title": "Maps in Flutter",
								"date": "01/15/2018",
								"tags": [
									"flutter",
									"maps",
									"dart"
								],
								"category": "Flutter",
								"cover": "http://res.cloudinary.com/ericwindmill/image/upload/v1516675871/Flutter_Maps_tjqj04.png",
								"type": "post",
								"month": "January",
								"author": "Matthew Smith",
								"year": "2018",
								"description": "Flutter is still in alpha and as such, still has functional dark spots. Fortunately, the Flutter team has come up with a great solution by allowing early adopters to build plugins. We built a maps solution.",
								"external": "https://medium.com/@matthew.smith_66715/maps-in-flutter-a1ac49ab554b"
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/sharing-code-on-i-os-android-and-the-web"
							},
							"frontmatter": {
								"title": "Sharing Code on iOS, Android, and the Web",
								"date": "01/10/2018",
								"tags": [
									"flutter",
									"business",
									"ios",
									"android",
									"dart"
								],
								"category": "Flutter",
								"cover": "http://res.cloudinary.com/ericwindmill/image/upload/v1516675872/post_header_gdgxpz.png",
								"type": "post",
								"month": "January",
								"author": "John Ryan",
								"year": "2018",
								"description": "After a long relationship with native iOS and Android development, we are ending it. We’ve met someone new, named Flutter.",
								"external": "https://medium.com/@john.p.ryan4/sharing-code-on-ios-android-and-web-85e8ed7dfccd"
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/how-flutter-has-changed-our-company-for-the-better"
							},
							"frontmatter": {
								"title": "How Flutter Has Changed Our Company (for the Better)",
								"date": "01/03/2018",
								"tags": [
									"flutter",
									"business",
									"native",
									"ios",
									"android",
									"dart"
								],
								"category": "Flutter",
								"cover": "https://cdn-images-1.medium.com/max/1600/1*oUyZxsBi_aS6jVhL8sjCsQ.png",
								"type": "post",
								"month": "January",
								"author": "Matthew Smith",
								"year": "2018",
								"description": "An appeal to the native iOS and Android developers of the world — there is a better way.",
								"external": "https://medium.com/@matthew.smith_66715/why-we-chose-flutter-and-how-its-changed-our-company-for-the-better-271ddd25da60"
							}
						}
					}
				]
			}
		},
		"pathContext": {}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---blog-9e6c4abff8bb80cfb5b4.js